<template>
  <div
    class="status-icon-dropdown-wrap"
    :class="{ 'disabled-edit': disableStatusEdit }"
    :data-list-id="listId"
  >
    <v-popover
      interactive
      tag="div"
      content-tag="div"
      :role="'poper'"
      :trigger="'click'"
      :append-to="bodyRef"
      :on-show="onShow"
      class="flex"
      content-class="status-icon-dropdown-popover"
    >
      <template #default="{ state }">
        <div
          class="status-icon-wrap"
          :class="[
            { active: state.isVisible && !disableStatusEdit },
            { disabled: disableStatusEdit },
            { 'allow-update': !disableStatusEdit && hasSprintSettingsStatus },
          ]"
          :data-list-id="listId"
        >
          <em
            :data-list-id="listId"
            class="child-card-status-icon"
            :style="{
              ...getCustomIconStyle(iconPath(statusIcon || '')),
              backgroundColor: statusColor,
            }"
          />
        </div>
      </template>
      <template #content="{ state, hide }">
        <ListCardStatusPicker
          v-if="state.isVisible"
          :selected-status="displayStatus"
          :custom-statuses-list="customStatusesList"
          :allow-color-change="allowColorChange"
          :show-dropdown-label="showDropdownLabel"
          @click="handleStatusItemClick($event, hide)"
          @colorSelect="handleColorSelect"
          @esc="hide"
        />
      </template>
    </v-popover>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import ListCardStatusPicker from './ListCardStatusPicker';

export default {
  name: 'StatusIconPicker',

  components: {
    ListCardStatusPicker,
  },

  mixins: [customIconsMixin],

  props: {
    statusIcon: {
      type: String,
      required: true,
    },

    statusColor: {
      type: String,
      required: true,
    },

    selectedStatus: {
      type: Object,
      required: true,
    },

    customStatusesList: {
      type: Array,
      required: false,
      default: () => [],
    },

    allowColorChange: {
      type: Boolean,
      required: false,
      default: true,
    },

    showDropdownLabel: {
      type: Boolean,
      required: false,
      default: true,
    },

    disableStatusEdit: {
      type: Boolean,
      required: false,
      default: false,
    },

    listId: {
      type: [String, Number],
      required: false,
      default: '',
    },

    sprintSettingsStatusIndex: {
      type: Number,
      required: false,
      default: -1,
    },
  },

  emits: ['statusItemClick', 'colorSelect'],
  setup() {
    return {
      bodyRef: document.body,
    };
  },

  data() {
    return {
      displayStatus: this.selectedStatus,
    };
  },

  computed: {
    hasSprintSettingsStatus() {
      return this.sprintSettingsStatusIndex !== -1;
    },
  },

  methods: {
    onShow() {
      this.displayStatus = this.selectedStatus;
      return !this.disableStatusEdit;
    },
    handleStatusItemClick(status, hideFn) {
      if (typeof hideFn === 'function') hideFn();
      this.$emit('statusItemClick', status);
    },
    handleColorSelect(color) {
      this.$emit('colorSelect', color);
    },
  },
};
</script>

<style lang="scss">
.status-icon-dropdown-wrap {
  position: relative;

  &.disabled {
    pointer-events: none;
    .status-icon-wrap {
      border: 1px solid $error700;
    }
  }

  .status-icon-wrap {
    display: flex;
    min-width: 24px;
    min-height: 24px;
    border: 1px solid transparent;
    border-radius: 4px;
    align-items: center;
    justify-content: center;

    &:hover,
    &.active {
      border: 1px solid $gray200;
    }

    &.allow-update {
      min-width: 22px;
      min-height: 22px;
      outline: 1px solid var(--importantElBorder);
    }
  }

  .child-card-status-icon {
    width: 16px;
    height: 16px;
    display: block;
  }
}
</style>
